import React from "react";

// material-ui components
import withStyles from "material-ui/styles/withStyles";
import FormControlLabel from "material-ui/Form/FormControlLabel";
import Switch from "material-ui/Switch";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  choiche: {
    textAlign: "center",
    cursor: "pointer",
    marginTop: "20px"
  },
  ...customSelectStyle,
  ...customCheckboxRadioSwitch
};

class Step3 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      available: false,
    };
  }
  handleSimple = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  handleChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };
  isValidated() {
    return true;
  }
  render() {
    const { classes } = this.props;
    return (
      <div>
        <h4 className={classes.infoText}>What is your availability?</h4>
        <GridContainer justify="center">
          <ItemGrid xs={12} sm={12} md={12} lg={10}>
            <FormControlLabel
                control={
                  <Switch
                    checked={this.state.available}
                    onChange={this.handleChange("available")}
                    value="available"
                    classes={{
                      checked: classes.switchChecked,
                      bar: classes.switchBarChecked,
                      icon: classes.switchIcon,
                      default: classes.switchUnchecked,
                      iconChecked: classes.switchIconChecked
                    }}
                  />
                }
                classes={{
                  label: classes.label
                }}
                label="This location is available."
              />
          </ItemGrid>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(style)(Step3);





// WEBPACK FOOTER //
// ./src/views/Receiver/AddLocationWizardSteps/Step3.jsx